module.exports = __webpack_public_path__ + "img/6.3473ba10.png";